function o(t, a, r, u, n, s, l) {
  var e = /* @__PURE__ */ new Date(0);
  return e.setUTCFullYear(t, a, r), e.setUTCHours(u, n, s, l), e;
}
export {
  o as default
};
